const TOKEN_KEY = "profileToken";
const CHOSEN_AT_KEY = "profileChosenAt";

const read = (key: string): string | null => {
  try {
    return localStorage.getItem(key);
  } catch {
    return null;
  }
};

const write = (key: string, value: string | null) => {
  try {
    if (value === null) localStorage.removeItem(key);
    else localStorage.setItem(key, value);
  } catch {
    /* private mode; the session still works for this run */
  }
};

let token: string | null = read(TOKEN_KEY);
let chosenAt: string | null = read(CHOSEN_AT_KEY);

// Sessions from before the main profile kept a token: pick again to get one
if (chosenAt && !token) {
  chosenAt = null;
  write(CHOSEN_AT_KEY, null);
}
let isSwitching = false;
let isLoggingOut = false;

const listeners = new Set<() => void>();

const emit = () => listeners.forEach((listener) => listener());

export const getProfileToken = () => token;

export const getProfileChosenAt = () => chosenAt;

const markChosen = () => {
  chosenAt = String(Date.now());
  write(CHOSEN_AT_KEY, chosenAt);
};

export const getIsProfileSwitching = () => isSwitching;

export const getIsLoggingOut = () => isLoggingOut;

export const setLoggingOut = (value: boolean) => {
  if (isLoggingOut === value) return;
  isLoggingOut = value;
  emit();
};

export const setProfileSwitching = (value: boolean) => {
  if (isSwitching === value) return;
  isSwitching = value;
  emit();
};

export const subscribeProfileSession = (listener: () => void) => {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
};

export const setProfileSession = (nextToken: string) => {
  token = nextToken;
  write(TOKEN_KEY, nextToken);
  markChosen();
  emit();
};

export const clearProfileSession = () => {
  token = null;
  chosenAt = null;
  write(TOKEN_KEY, null);
  write(CHOSEN_AT_KEY, null);
  emit();
};

// A dead token leaves no way to tell which profile it was, so pick again
export const expireProfileToken = () => {
  if (token) clearProfileSession();
};
